export const LOGIN_ROUTE_NAME = 'login';
export const REGISTER_ROUTE_NAME = 'register';
export const LOGOUT_ROUTE_NAME = 'logout';
export const HOME_ROUTE_NAME = 'home';
export const ABOUT_ROUTE_NAME = 'about';
export const CONTACT_ROUTE_NAME = 'contact';
export const MY_ACCOUNT_ROUTE_NAME = 'my-account';
export const MY_CONTACTS_ROUTE_NAME = '/my-account/my-contacts';
export const MY_CONTACTS_HISTORY_ROUTE_NAME = '/my-account/my-contacts-history';
export const CONTACT_CENTER_ROUTE_NAME = '/contact-center';
export const CONTACT_CENTER_SETTINGS_ROUTE_NAME = '/contact-center/settings';
export const MY_PROFILE_ROUTE_NAME = '/my-account/my-profile';
export const FAQ_ROUTE_NAME = 'faq';
export const USER_HOME_ROUTE_NAME = 'home';
const routeAllies = {
  landing: {
    home: HOME_ROUTE_NAME,
    about: ABOUT_ROUTE_NAME,
    contact: CONTACT_ROUTE_NAME,
    my_account: MY_ACCOUNT_ROUTE_NAME,
    my_contacts: MY_CONTACTS_ROUTE_NAME,
    my_contacts_history: MY_CONTACTS_HISTORY_ROUTE_NAME,
    my_profile: MY_PROFILE_ROUTE_NAME,
    contact_center: CONTACT_CENTER_ROUTE_NAME,
    contact_center_settings: CONTACT_CENTER_SETTINGS_ROUTE_NAME,
    faq: FAQ_ROUTE_NAME,
    resetpassword: 'reset-password/:token/:email',
  },
  auth: {
    login: LOGIN_ROUTE_NAME,
    register: REGISTER_ROUTE_NAME,
    logout: {
      path: `/${LOGOUT_ROUTE_NAME}`,
      name: LOGOUT_ROUTE_NAME
    }
  },
  user: {
    profile: 'profile',
    index: 'user-index',
  },
};
// console.log(routeAllies);
export default routeAllies;
